import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const devConfig = {
    apiKey: "AIzaSyBQlql9DwH2ulmH_Nz59HiI0zNF4EYQbLE",
    authDomain: "yoganosh-935e5.firebaseapp.com",
    databaseURL: "https://yoganosh-935e5.firebaseio.com",
    projectId: "yoganosh-935e5",
    storageBucket: "yoganosh-935e5.appspot.com",
    messagingSenderId: "297347057748"
};

const prodConfig = {
    apiKey: "AIzaSyCbELxDvml9IELRtz_cX2ozNZxM8pXJUGQ",
    authDomain: "yoganosh-87b9f.firebaseapp.com",
    databaseURL: "https://yoganosh-87b9f.firebaseio.com",
    projectId: "yoganosh-87b9f",
    storageBucket: "yoganosh-87b9f.appspot.com",
    messagingSenderId: "901622812713"
};

const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

if (!firebase.apps.length) {
    firebase.initializeApp(config);
}

export default firebase;


// WEBPACK FOOTER //
// ./src/firebase/firebase.js